import { wrapApiCall } from '@/lib/axios'
import { AxiosInstance } from 'axios'
import { deserialize } from 'ts-jackson'
import {
  AtRiskItem,
  AtRiskPage,
  AtRiskQueryParams,
  MemberDetail,
  PtPerformance,
  ScatterPoint,
  SessionUtilizationFilter,
  SessionUtilizationSummary,
} from './model'

interface ApiEnvelope<T> {
  data: T
}

export const SessionUtilizationService = (client: AxiosInstance) => {
  return {
    async getSummary(params: SessionUtilizationFilter = {}): Promise<SessionUtilizationSummary> {
      const { data } = await wrapApiCall(() =>
        client.get<ApiEnvelope<Record<string, unknown>>>('/session-utilization/summary', { params })
      )
      return deserialize(data?.data ?? {}, SessionUtilizationSummary)
    },

    async getScatter(params: SessionUtilizationFilter = {}): Promise<ScatterPoint[]> {
      const { data } = await wrapApiCall(() =>
        client.get<ApiEnvelope<Record<string, unknown>[]>>('/session-utilization/scatter', {
          params,
        })
      )
      return (data?.data ?? []).map((item) => deserialize(item, ScatterPoint))
    },

    async getPtPerformance(params: SessionUtilizationFilter = {}): Promise<PtPerformance[]> {
      const { data } = await wrapApiCall(() =>
        client.get<ApiEnvelope<Record<string, unknown>[]>>('/session-utilization/pt-performance', {
          params,
        })
      )
      return (data?.data ?? []).map((item) => deserialize(item, PtPerformance))
    },

    async getAtRisk(params: AtRiskQueryParams = {}): Promise<AtRiskPage> {
      const { data } = await wrapApiCall(() =>
        client.get<ApiEnvelope<Record<string, unknown>>>('/session-utilization/at-risk', { params })
      )
      const payload = data?.data ?? {}
      const items = ((payload.items as Record<string, unknown>[]) ?? []).map((it) =>
        deserialize(it, AtRiskItem)
      )
      return AtRiskPage.from({
        total: Number(payload.total ?? 0),
        page: Number(payload.page ?? 1),
        limit: Number(payload.limit ?? items.length),
        items,
      })
    },

    async getMemberDetail(memberId: string | number): Promise<MemberDetail> {
      const { data } = await wrapApiCall(() =>
        client.get<ApiEnvelope<Record<string, unknown>>>(`/session-utilization/members/${memberId}`)
      )
      return deserialize(data?.data ?? {}, MemberDetail)
    },
  }
}
